import React from 'react';
import SentimentDissatisfiedOutlinedIcon from '@mui/icons-material/SentimentDissatisfiedOutlined';
import './EmptyPage.css';

const EmptyPage = (props) => {
  return (
    <div className='text-white'>
      <h3>My {props.title}</h3>
      <div className='text-center order-div'>
        <SentimentDissatisfiedOutlinedIcon className='cl-pm' />
        <h1>Oops!!!</h1>
        <p> {props.text}.</p>
      </div>
    </div>
  )
}

export default EmptyPage;